import { createFileRoute } from "@tanstack/react-router";
import "@fontsource/fragment-mono/latin-400.css";
import "@fontsource/special-gothic-expanded-one/latin-400.css";
import { Wishes } from "@/components/soad/About";
import { Page } from "@/components/soad/Pages";
import "@/styles/soad.css";

export const Route = createFileRoute("/about")({ component: AboutPage });

function AboutPage() {
  return (
    <Page>
      <Wishes />
    </Page>
  );
}
